import { styled } from '@mui/material'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { transform } from 'typescript'

interface StyledNavLinkProps extends NavLinkProps {
  fontWeight?: number
  mode?: 'dark' | 'light'
}

interface StyledNavALinkProps {
  fontWeight?: number
  mode?: 'dark' | 'light'
}

export const StyledNavLink = styled(NavLink)<StyledNavLinkProps>(
  ({ theme, fontWeight, mode }) => ({
    color: mode === 'dark' ? 'var(--black)' : 'var(--white)',
    paddingBottom: 'clamp(5px,1vw,10px)',
    lineHeight: 'clamp(1em,2vw,24px)',
    fontWeight: fontWeight ? fontWeight : 400,
    fontSize: 'clamp(16px,1.8vw,20px)',
    letterSpacing: '0.8px',
    position: 'relative',
    ['&:after']: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      width: '0',
      height: '3px',
      backgroundColor: mode === 'dark' ? 'var(--black)' : 'var(--white)',
      transition: 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      transform: 'translateX(-50%)'
    },
    ['&:hover:after']: {
      width: '100%'
    },
    ['&.active:after']: {
      width: '100%'
    }
  })
)

export const StyledALink = styled('a')<StyledNavALinkProps>(
  ({ theme, fontWeight, mode }) => ({
    color: mode === 'dark' ? 'var(--black)' : 'var(--white)',
    paddingBottom: 'clamp(5px,1vw,10px)',
    lineHeight: 'clamp(1em,2vw,24px)',
    fontWeight: fontWeight ? fontWeight : 400,
    fontSize: 'clamp(16px,1.8vw,20px)',
    letterSpacing: '0.8px',
    position: 'relative',
    transition: 'var(--transition)',
    ['&:after']: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      width: '0',
      height: '3px',
      backgroundColor: mode === 'dark' ? 'var(--black)' : 'var(--white)',
      transition: 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      transform: 'translateX(-50%)'
    },
    ['&:hover:after']: {
      width: '100%'
    },
    ['&.active:after']: {
      width: '100%'
    }
  })
)

export const StyledLi = styled('li')({
  margin: '0 calc(clamp(15px,2vw,34px) / 2)',
  marginBottom: '2px'
})

export const StyledUl = styled('ul')({
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  alignItems: 'center',
  rowGap: '10px',
  margin: 0,
  padding: 0,
  listStyle: 'none',
  transition: 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  ['&.mobile']: {
    flexDirection: 'column'
  },
  ['&.mobile li']: {
    margin: '0',
    marginBottom: '2px',
    lineHeight: '1'
  },
  ['&.mobile li a']: {
    fontSize: '16px',
    padding: '0 0 10px',
    display: 'block',
    lineHeight: '1em'
  },
  ['&.footer']: {
    justifyContent: 'center',
    ['li a']: {
      fontSize: '16px',
      ['&:after']: {
        display: 'none'
      },
      ['&:hover']: {
        color: 'var(--hover-blue)'
      }
    }
  }
})
